import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { PublicClientApplication } from "@azure/msal-browser";

import "./index.css";
import reportWebVitals from "./reportWebVitals";
import App from "../src/app/App";
import store from "./store";
import { msalConfig } from "./authConfig";
import { BrowserRouter as Router } from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";

export const msalInstance = new PublicClientApplication(msalConfig);

// Component
const AppProvider = () => (
  <Provider store={store}>
    <Router>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </Router>
  </Provider>
);

ReactDOM.render(<AppProvider />, document.getElementById("root"));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
